import { createBrowserRouter } from "react-router";
import { PageLayoutContainer } from "@features/pageLayout/containers/PageLayoutContainer";
import { AppRoutes } from "@/shared/constants/Routes";
import { OTTPurchasePage } from "@/pages/OTTPurchase/OTTPurchasePage";
import { ErrorPage } from "@/pages/ErrorPage/ErrorPage";
import { OFClubPurchasePage } from "@/pages/OFClubPurchase/OFClubPurchasePage";
import { Page404 } from "@/pages/404";
import { ThankYouPage } from "@/pages/ThankYou/ThankYouPage";
import { ProtectedRoute } from "@features/ProtectedRoute";

const appRoutes = [
  {
    element: <PageLayoutContainer />,
    children: [
      {
        path: `/:lang?${AppRoutes.OTT}`,
        children: [
          {
            path: AppRoutes.Purchase,
            children: [
              {
                path: AppRoutes.OTTOfferId,
                element: (
                  <ProtectedRoute>
                    <OTTPurchasePage />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: `/:lang?${AppRoutes.OFC}`,
        children: [
          {
            path: AppRoutes.Purchase,
            children: [
              {
                path: AppRoutes.SKU,
                element: <OFClubPurchasePage />,
              },
            ],
          },
        ],
      },
      {
        path: `/:lang?${AppRoutes.ThankYou}`,
        element: <ThankYouPage />,
      },
      {
        path: "*",
        element: <Page404 />,
      },
    ],
    errorElement: <ErrorPage />,
  },
];

export const appRouter = createBrowserRouter(appRoutes);
